/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListRiskResultsForAgentSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRiskResultsForAgentSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRiskResultsForAgentSecurity = {
  option1?: ListRiskResultsForAgentSecurityOption1 | undefined;
  option2?: ListRiskResultsForAgentSecurityOption2 | undefined;
};

export type ListRiskResultsForAgentRequest = {
  /**
   * Optional policy ID to filter by.
   */
  policyId?: string | undefined;
  /**
   * Optional chat ID to filter by.
   */
  chatId?: string | undefined;
  /**
   * Optional concrete MCP server ID to match exactly.
   */
  mcpServerId?: string | undefined;
  /**
   * Optional rule category key to filter by (e.g. secrets, pii, financial).
   */
  category?: string | undefined;
  /**
   * Optional rule identifier substring to filter by (case-insensitive, e.g. 'secret' matches all 'secret.*' rules).
   */
  ruleId?: string | undefined;
  /**
   * Optional user identifier substring to filter by (case-insensitive, matched against the chat's external user id).
   */
  userId?: string | undefined;
  /**
   * If true, collapse results to one row per (policy_id, rule_id, match), keeping the most recent occurrence. Useful when the same secret is detected many times within a single message body.
   */
  uniqueMatch?: boolean | undefined;
  /**
   * If true, only return findings from chats that are not linked to an assistant. Useful for surfacing events that are missing user attribution.
   */
  nonAssistant?: boolean | undefined;
  /**
   * Optional assistant ID; only return findings from chats linked to this assistant.
   */
  assistantId?: string | undefined;
  /**
   * Filter results to messages created at or after this timestamp (ISO 8601).
   */
  from?: Date | undefined;
  /**
   * Filter results to messages created strictly before this timestamp (ISO 8601).
   */
  to?: Date | undefined;
  /**
   * Cursor to fetch the next page of results.
   */
  cursor?: string | undefined;
  /**
   * Maximum number of results to return per page.
   */
  limit?: number | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListRiskResultsForAgentSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRiskResultsForAgentSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListRiskResultsForAgentSecurityOption1$Outbound,
    ListRiskResultsForAgentSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listRiskResultsForAgentSecurityOption1ToJSON(
  listRiskResultsForAgentSecurityOption1:
    ListRiskResultsForAgentSecurityOption1,
): string {
  return JSON.stringify(
    ListRiskResultsForAgentSecurityOption1$outboundSchema.parse(
      listRiskResultsForAgentSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRiskResultsForAgentSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRiskResultsForAgentSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListRiskResultsForAgentSecurityOption2$Outbound,
    ListRiskResultsForAgentSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listRiskResultsForAgentSecurityOption2ToJSON(
  listRiskResultsForAgentSecurityOption2:
    ListRiskResultsForAgentSecurityOption2,
): string {
  return JSON.stringify(
    ListRiskResultsForAgentSecurityOption2$outboundSchema.parse(
      listRiskResultsForAgentSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRiskResultsForAgentSecurity$Outbound = {
  Option1?: ListRiskResultsForAgentSecurityOption1$Outbound | undefined;
  Option2?: ListRiskResultsForAgentSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRiskResultsForAgentSecurity$outboundSchema: z.ZodMiniType<
  ListRiskResultsForAgentSecurity$Outbound,
  ListRiskResultsForAgentSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRiskResultsForAgentSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRiskResultsForAgentSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRiskResultsForAgentSecurityToJSON(
  listRiskResultsForAgentSecurity: ListRiskResultsForAgentSecurity,
): string {
  return JSON.stringify(
    ListRiskResultsForAgentSecurity$outboundSchema.parse(
      listRiskResultsForAgentSecurity,
    ),
  );
}

/** @internal */
export type ListRiskResultsForAgentRequest$Outbound = {
  policy_id?: string | undefined;
  chat_id?: string | undefined;
  mcp_server_id?: string | undefined;
  category?: string | undefined;
  rule_id?: string | undefined;
  user_id?: string | undefined;
  unique_match?: boolean | undefined;
  non_assistant?: boolean | undefined;
  assistant_id?: string | undefined;
  from?: string | undefined;
  to?: string | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRiskResultsForAgentRequest$outboundSchema: z.ZodMiniType<
  ListRiskResultsForAgentRequest$Outbound,
  ListRiskResultsForAgentRequest
> = z.pipe(
  z.object({
    policyId: z.optional(z.string()),
    chatId: z.optional(z.string()),
    mcpServerId: z.optional(z.string()),
    category: z.optional(z.string()),
    ruleId: z.optional(z.string()),
    userId: z.optional(z.string()),
    uniqueMatch: z.optional(z.boolean()),
    nonAssistant: z.optional(z.boolean()),
    assistantId: z.optional(z.string()),
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      policyId: "policy_id",
      chatId: "chat_id",
      mcpServerId: "mcp_server_id",
      ruleId: "rule_id",
      userId: "user_id",
      uniqueMatch: "unique_match",
      nonAssistant: "non_assistant",
      assistantId: "assistant_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRiskResultsForAgentRequestToJSON(
  listRiskResultsForAgentRequest: ListRiskResultsForAgentRequest,
): string {
  return JSON.stringify(
    ListRiskResultsForAgentRequest$outboundSchema.parse(
      listRiskResultsForAgentRequest,
    ),
  );
}
